import { Button } from '@src/design-system/button';
import { cn } from '@src/design-system/helpers';
import { useAssistantStore } from '../store/assistant-store';
import LauncherIcon from '../assets/launcher-icon';

export function AssistantLauncher() {
  const isOpen = useAssistantStore((s) => s.isOpen);
  const toggle = useAssistantStore((s) => s.toggle);

  return (
    <Button
      type='button'
      variant='primaryOutline'
      size='lg'
      aria-label='Ask Tia'
      aria-pressed={isOpen}
      onClick={toggle}
      className={cn(
        'space-x-0 h-12 rounded-2xl border-primary-200 px-3 text-base font-normal text-gray-800'
      )}
    >
      <span className='relative block shrink-0'>
        <LauncherIcon />
      </span>
      <span>Ask Tia</span>
    </Button>
  );
}
